import ModalManager from './ModalManager';
import { connect } from 'react-redux';
import { AppState } from '../../../../state/createStore';
import { bindActionCreators, Dispatch } from 'redux';
import { closeModal } from '../../../../state/session/session.actions';

function mapStateToProps(state: AppState) {
  return {
    modals: state.session.modals,
    isRTL: state.platformParams.isRTL,
    isEditorX: state.platformParams.isEditorX,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      closeModal,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalManager);
